import { HeatLossEstimateMethod } from '@/gql/graphql';
import { Alert } from '@payaca/ambrosia';
import { FC } from 'react';
import { METHOD_DESCRIPTION } from '../heatLossEstimateMethodDescription';

type HeatLossAssumptionsAlertProps = {
  method: HeatLossEstimateMethod;
  targetIndoorTemperatureC: number;
};

const HeatLossAssumptionsAlert: FC<HeatLossAssumptionsAlertProps> = (props) => {
  const { method, targetIndoorTemperatureC } = props;

  return (
    <Alert
      iconName="info-circle.3"
      className="border-gray-200 bg-gray-50 text-gray-600 dark:border-white/10 dark:bg-white/10 dark:text-gray-400"
    >
      <p>
        This is an initial Estimate using {METHOD_DESCRIPTION[method]}.
        Calculations are based on an indoor temperature of{' '}
        {targetIndoorTemperatureC} °C.
      </p>
    </Alert>
  );
};

export default HeatLossAssumptionsAlert;
